import { mutateAdmin } from '../graphql-client';

export type ImportMode = 'replace' | 'fail' | 'preserve';

export type ImportProjectMutationParams = {
  uri: string;
  name?: string;
  projectId?: string;
  mode?: ImportMode;
  servicesMode?: ImportMode;
};

export type ImportProjectMutationResponse = {
  id: string;
};

const IMPORT_PROJECT_MUTATION = /* GraphQL */ `
mutation ($uri: String!, $name: String, $projectId: String, $mode: ImportMode, $servicesMode: ImportMode) {
  id: importProject(uri: $uri, name: $name, projectId: $projectId, mode: $mode, servicesMode: $servicesMode, origin: "@takeshape/client")
}`;

export type GetProjectImportParams = {
  id: string;
  projectId?: string;
};

export type GetProjectImportResponse = {
  getProjectImport: null | {
    status: string;
    message: string | null;
    projectId: string | null;
  };
};

export const importProject = mutateAdmin(IMPORT_PROJECT_MUTATION);
